module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-27.8e06e62c.png";